import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getDocCategoryTypeTree() {
  return request({
    url: URL.sys.docCategoryTypeTree,
    method: 'get'
  })
}

export function getDocCategoryTypeTreeByLob(params) {
  return request({
    url: URL.sys.docCategoryTypeTreeByLob,
    method: 'get',
    params
  })
}

export function getDocCategoryNextLevel(lob) {
  return request({
    url: URL.sys.docCategoryNextLevel,
    method: 'get',
    params: { lob: lob }
  })
}

export function docCategoryCodeExists(code, uuid, lob) {
  const params = { code: code, uuid: uuid, lob: lob }
  return request({
    url: URL.sys.docCategoryCodeExists,
    method: 'get',
    params
  })
}

export function docCategoryDetail(uuid) {
  const params = { uuid }
  return request({
    url: URL.sys.docCategoryDetail,
    method: 'get',
    params
  })
}

export function addDocCategory(data) {
  return request({
    url: URL.sys.docCategory,
    method: 'post',
    data
  })
}

export function updateDocCategory(data) {
  return request({
    url: URL.sys.docCategory,
    method: 'put',
    data
  })
}

export function deleteDocCategory(uuid) {
  return request({
    url: URL.sys.docCategory,
    method: 'delete',
    params: { uuid }
  })
}

export function getDocumentTypeByExt(params) {
  return request({
    url: URL.sys.getDocumentTypeByExt,
    method: 'get',
    params
  })
}
